import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Hero from '../components/news/Hero';
import { Link } from 'react-router-dom';

const News: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Hero />
      <div className="news-page pt-3 margin-top-75">
        <Container>
          {/* President's Message Section */}
          <Row className="align-items-start president-message p-0">
            <Col lg={6} className="ps-0 column-left">
              <div className="message-card position-relative rounded">
                <img 
                  src="/images/News/1.jpg" 
                  alt={t('news.hero.title')}
                  className="message-image w-100 h-100 image-hover-animation"
                />
              </div>
            </Col>
            <Col lg={6} className="pe-0 column-right">
              <div className="message-content pe-0">
                <h2 className="message-title">{t('news.title')}</h2>
                <div className="message-text">
                  <p className='text-justify'>
                    <span className='menu-item'>{t('about.history.header')} </span>{t('news.description-1')}
                    <span className='menu-item'> {t('news.president')}</span>{t('news.description-2')}
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Top News Section */}
          <Row className="top-news">
            {/* Right Side Small News */}
            <Col lg={6} className="ps-0 column-left">
              <Row className="g-2">
                <Col xs={12}>
                  <div className="news-card medium position-relative">
                    <div className="news-category">{t('news.category')}</div>
                    <img 
                      src="/images/News/2.jpg" 
                      alt={t('news.articles.receivingCertificate.title')}
                      className="news-image w-100 h-100 image-hover-animation"
                    />
                    <div className="news-content">
                      <h3>{t('news.articles.receivingCertificate.title')}</h3>
                    </div>
                    <Button as={Link as any} to="/news/receiving-certificate-from-cla" className="news-read-more">{t('news.readMore')}</Button>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="news-card small position-relative">
                    <div className="news-category">{t('news.category')}</div>
                    <img 
                      src="/images/News/Sub-news/13.2.jpg" 
                      alt={t('news.articles.meetingWithOfficer.title')}
                      className="news-image w-100 h-100 image-hover-animation"
                    />
                    <div className="news-content">
                      <h3>{t('news.articles.meetingWithOfficer.title')}</h3>
                    </div>
                    <Button as={Link as any} to="/news/meeting-with-officer" className="news-read-more">{t('news.readMore')}</Button>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="news-card small position-relative">
                    <div className="news-category">{t('news.category')}</div>
                    <img 
                      src="/images/News/5.jpg" 
                      alt={t('news.articles.strategyMeeting.title')}
                      className="news-image w-100 h-100 image-hover-animation"
                    />
                    <div className="news-content">
                      <h3>{t('news.articles.strategyMeeting.title')}</h3>
                    </div>
                    <Button as={Link as any} to="/news/strategy-meeting" className="news-read-more">{t('news.readMore')}</Button>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Right: Large Charity News */}
            <Col lg={6} className="pe-0 column-right">
              <div className="news-card large position-relative">
                <div className="news-category">{t('news.category')}</div>
                <img 
                  src="/images/News/3.jpg" 
                  alt={t('news.articles.charity.title')}
                  className="news-image w-100 h-100 image-hover-animation"
                />
                <div className="news-content">
                  <h3>{t('news.articles.charity.title')}</h3>
                </div>
                <Button as={Link as any} to="/news/charity" className="news-read-more">{t('news.readMore')}</Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default News; 